export const optionStatusBin = [
  { value: 0, label: 'Não informado' },
  { value: 1, label: 'Ativo' },
  { value: 2, label: 'Inativo' },
];

export const optionStatusBinSimNao = [
  { value: 0, label: 'Não informado' },
  { value: 1, label: 'Sim' },
  { value: 2, label: 'Não' },
];
